import { render, staticRenderFns } from "./TimeQuestion.vue?vue&type=template&id=0d08009c&scoped=true&"
import script from "./TimeQuestion.vue?vue&type=script&lang=js&"
export * from "./TimeQuestion.vue?vue&type=script&lang=js&"
import style0 from "./TimeQuestion.vue?vue&type=style&index=0&id=0d08009c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d08009c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VBtn,VTimePicker})
